import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import { singularityStore } from "@/store/store";
import * as t from "io-ts";
import { SiteStateV } from "@/futurelayer/settings/types";

/**
 * Get the FutureLayer claim URL from the store
 */
export function getClaimUrl(): string {
  return singularityStore.siteStatus.claimUrl;
}

/**
 * Check if the current URL contains a claim_key parameter
 */
export function checkForClaimKeyInUrl(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get("claim_key");
}

/**
 * Process a claim key by calling the AJAX endpoint
 */
export async function processClaimKey(claimKey: string): Promise<boolean> {
  console.log("Processing claim key:", claimKey);

  const result = await makeWordPressAjaxRequest({
    action: "futurelayer_process_claim_key_ajax",
    dataToPost: { claim_key: claimKey },
    decoder: t.type({
      success: t.boolean,
      message: t.string,
      site_state: SiteStateV
    }),
    suppressErrorLogging: false,
    friendlyName: "Process Claim Key"
  });

  if (result._tag === "Right" && result.right.success) {
    console.log("Claim successful:", result.right.message);

    // Update the store to reflect claimed status and new site state
    singularityStore.setSiteStatus({
      ...singularityStore.siteStatus,
      isClaimed: true,
      siteState: result.right.site_state
    });

    return true;
  }

  console.error(
    "Claim failed:",
    result._tag === "Right" ? result.right.message : "Unknown error"
  );
  return false;
}

/**
 * Remove the claim_key parameter from the URL
 */
export function cleanupClaimKeyFromUrl(): void {
  const url = new URL(window.location.href);
  url.searchParams.delete("claim_key");
  window.history.replaceState({}, "", url.toString());
}

/**
 * Check for and process claim key on page load
 */
export async function handleClaimKeyOnLoad(): Promise<void> {
  const claimKey = checkForClaimKeyInUrl();

  if (claimKey) {
    await processClaimKey(claimKey);
  }
}
